import styled from 'styled-components';
import Image from '../../../../../../../stories/components/hotels/common/Image/Image';
import ArrowDownIcon from '../../../../../../../stories/Icons/ArrowDownIcon';
import {
  FlexWrap,
  BaseColumnWrap,
  FlexItemCenter,
} from '../../../../../../../stories/components/CommonStyleUtils/dwebCommon.styles';
import {headingSizes} from '@stencil/build-theme';

export const MenuUIWrapper = styled.div(
  props => `
  width: 100%;
  border: 1px solid #e1e7ee;
  border-radius: ${props.theme.misc.borderRadius.custom(12)};
  margin-bottom:${props.theme.spacing.custom(16)};
  cursor:pointer;
`,
);
export const HeadingWrap = styled.div(
  props => `
    display:flex;
    justify-content:space-between;
    align-items:center;
    padding: ${props.theme.spacing.custom(18)};
    background:#e8f3ff;
    border-radius: ${props.theme.misc.borderRadius.custom(12)};
  `,
);
export const MenuHeader = styled.h3`
  ${headingSizes.MediumW1}
`;

export const OfferContent = styled.div(
  props => `
    display:${props.display || 'flex'};
    flex-direction: column;
      `,
);
export const ArrowDownNewWrap = styled(ArrowDownIcon)(
  props => `
    width:2rem;
    height:2rem;
    fill:${props.theme.colors.goBrandBlue.base};
    transform: ${props.transformStyle};
    transition: transform 0.5s;
    `,
);
export const OfferText = styled.span(
  props => `
    font-size: ${props.theme.font.custom(16)};
    margin-left: ${props.theme.spacing.base};
    margin-bottom: ${props.theme.spacing.custom(3)};
    `,
);
